import React from 'react';
import { Text, VStack } from '@chakra-ui/react';
import { useTokens } from '../../../../context/TokenProvider';
const EvidenceSentField = ({ name, value, ...rest }) => {
    const tokens = useTokens();
    return (React.createElement(VStack, { "data-testid": "evidence_sent_field", align: "flex-start", gap: tokens.Spacing02, ...rest },
        React.createElement(Text, { variant: "dk-800-md-4", "data-testid": "evidence_sent_wrapper__name" }, name),
        React.createElement(Text, { variant: "md-600-rg-4", "data-testid": "evidence_sent_wrapper__value" }, value)));
};
export default EvidenceSentField;
